import type React from 'react';

export const onClickHandlerForNonInteractiveElements = (
  onClickHandler: React.MouseEventHandler & React.KeyboardEventHandler,
) => ({
  role: 'button',
  tabIndex: '0',
  onClick: onClickHandler,
  onKeyPress: (event: React.KeyboardEvent) => {
    event.stopPropagation();
    const { code } = event;
    if (code === 'Enter') onClickHandler(event);
  },
});

export default onClickHandlerForNonInteractiveElements;
